import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  makeStyles,
  Paper,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import Map from "../../../components/map/Map";
import { useFetch } from "../../../features/customHooks/useFetch";

const useStyles = makeStyles((theme) => ({
  title: { fontWeight: "bold", fontSize: 15 },
  value: { fontSize: 15, marginLeft: 5 },
}));

const MapView = (props) => {
  const classes = useStyles();

  const { data } = props;
  const { loading = true, valuation = [], regetValuation } = data;

  const [mapData, setMapData] = useState(null);
  const [defaultCoords, setDefaultCoords] = useState([32.63296053018298, 51.3655310869217]);

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const handleOpenDialog = () => setEditDialogOpen(true);
  const handleCloseDialog = () => setEditDialogOpen(false);

  const [updateFetchState, setUpdateFetchParams] = useFetch();

  const getMapData = (data) => setMapData(data);

  const hanldeUpdateValuation = (event) => {
    const params = {
      method: "put",
      url: "/valuation/" + valuation?.id,
      data: {
        lat: mapData[0],
        lng: mapData[1],
      },
    };
    setUpdateFetchParams(params);
  };

  useEffect(() => {
    if (valuation?.lat && valuation?.lng) setDefaultCoords([parseFloat(valuation?.lat), parseFloat(valuation?.lng)]);
  }, [valuation]);

  useEffect(() => {
    if (!updateFetchState.loading && !updateFetchState.error && updateFetchState.data) {
      handleCloseDialog();
      regetValuation();
    }

    if (!updateFetchState.loading && updateFetchState.error) {
      console.log("error");
    }
  }, [updateFetchState]);

  return (
    <Paper style={{ padding: 10 }}>
      <Grid container alignItems='center'>
        <Typography variant='h6' style={{ fontWeight: "bold" }}>
          نقشه
        </Typography>

        <div style={{ flexGrow: 1 }} />

        {valuation?.can_edit && (
          <Tooltip title='ویرایش' onClick={handleOpenDialog}>
            <IconButton>
              <Edit />
            </IconButton>
          </Tooltip>
        )}
      </Grid>

      {loading ? (
        <Grid container alignItems='center' justifyContent='center'>
          <CircularProgress style={{ color: "#757575" }} />
        </Grid>
      ) : (
        <Grid container direction='row' style={{ marginTop: 10, height: 370 }}>
          <Map defaultCoords={defaultCoords} disabled />
        </Grid>
      )}
      <Dialog open={editDialogOpen} maxWidth={"md"} fullWidth>
        <DialogTitle>ویرایش آدرس</DialogTitle>
        <DialogContent>
          <div style={{ height: 370 }}>
            <Map getMapData={getMapData} defaultCoords={defaultCoords} />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>لغو</Button>
          <Button variant='contained' color='primary' onClick={hanldeUpdateValuation}>
            {updateFetchState?.loading ? <CircularProgress size={23} color='inherit' /> : "ویرایش"}
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default MapView;
